module.exports = __webpack_public_path__ + "img/web_5_2x.8bc4ac90.webp";